import {BsArrowRight} from "react-icons/bs"
import section01Styles from "./section01.module.css"
import {CmnComp} from "../../common/CmnComp"

const data = {
	header: "A Single Thought, Infinite Possibilities.",
	description: "Yi Nian Bazi is a profound exploration of the ancient Chinese art of destiny analysis, rooted in the principles of the Five Elements and Yin-Yang philosophy.",
	button: "Explore Yi Nian Bazi",
}

export const Section01 = () => {
	return (
		<section
			id="1"
			className={section01Styles.section01}
		>
			<div>
				<div>
					<h1 style={{color: "black", fontFamily: "Futura BT Pro Bold Italic", fontSize: "2.5rem"}}>Yi Nian Bazi</h1>
					<h5 style={{color: "black", fontFamily: "Futura BT Pro Bold Italic", fontSize: "1.5rem"}}>一念八字</h5>
				</div>
				<CmnComp props={data} />
			</div>

			<div>
				<div style={{margin: "1rem 0"}}>
					<h5 style={{color: "black", fontFamily: "Futura BT Pro Bold Italic", fontSize: "1.5rem"}}>一念八字</h5>
				</div>
				<img
					src="./Images/bazi_header.jpg"
					alt="Aesop_section01_image02"
				/>
			</div>

			<div>
				<img
					src="./Images/bazi_header.jpg"
					alt="bazi_header"
				/>
			</div>
		</section>
	)
}
